import service from "../util/http";

// 区域国家信息
export const getAreaCountryListApi = data => {
  return service({
    url: "/manage/saleDataController/areaCountryListMine",
    method: "post",
    data
  });
};

// 初级搜索列表
export const getPrimarySearchListApi = data => {
  return service({
    url: "/manage/saleDataController/saleDataList",
    method: "post",
    data
  });
};

// 高级搜索列表
export const getAdvancedSearchListApi = data => {
  return service({
    url: "/manage/saleDataController/saleDataListAdvanced",
    method: "post",
    data
  });
};

// 初级搜索导出
export const exportPrimarySearchApi = data => {
  return service({
    url: "/manage/saleDataController/exportSaleData",
    method: "post",
    responseType: "blob",
    data
  });
};

// 高级搜索导出
export const exportAdvancedSearchApi = data => {
  return service({
    url: "/manage/saleDataController/exportSaleDataAdvanced",
    method: "post",
    responseType: "blob",
    data
  });
};

// 信息列表
export const getInfoListApi = data => {
  return service({
    url: "/manage/saleInformationController/queryPageList",
    method: "post",
    data
  });
};

// 获取市场信息
export const getMarketInfoApi = data => {
  return service({
    url: "/manage/saleInformationController/getSaleInformation",
    method: "post",
    data
  });
};

// 新增|修改 基础信息，政治环境
export const addOrUpdateBaseInfoApi = data => {
  return service({
    url: "/manage/saleInformationController/insertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 经济环境
export const addOrUpdateEconomicEnvironmentApi = data => {
  return service({
    url: "/manage/saleInformationController/saveRate",
    method: "post",
    data
  });
};

// 获取历史销量导入
export const getHistorySalesImportApi = data => {
  return service({
    url: "/manage/saleDataController/informationHistorySale",
    method: "post",
    data
  });
};

// 新增|修改 TOP5车型 市场实销
export const addOrUpdateTop5CarModelApi = data => {
  return service({
    url: "/manage/saleDataController/saleDataTop5SaveOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 各品牌标杆车型 市场实销
export const addOrUpdateAllBrandCarModelApi = data => {
  return service({
    url: "/manage/saleDataController/saleDataEachSaveOrUpdate",
    method: "post",
    data
  });
};

// 获取行业信息
export const getIndustryInfoApi = data => {
  return service({
    url: "/manage/industryController/getData",
    method: "post",
    data
  });
};

// 新增|修改 基本物价信息
export const addOrUpdateBasePriceInfoApi = data => {
  return service({
    url: "/manage/industryController/basicPriceInsertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 基本政策
export const addOrUpdateBasePolicyApi = data => {
  return service({
    url: "/manage/industryController/industryPolicyInsertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 主要汽车品牌以及中国汽车品牌的生产销售模式
export const addOrUpdateProductionSaleModelApi = data => {
  return service({
    url: "/manage/industryController/productionBrandInsertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 汽车消费金融环境变化
export const addOrUpdateFinanceEnvironmentChangeApi = data => {
  return service({
    url: "/manage/industryController/carFinanceBrandInsertOrUpdate",
    method: "post",
    data
  });
};

// 获取竞争信息
export const getCompeteInfoApi = data => {
  return service({
    url: "/manage/saleCompetitionController/getData",
    method: "post",
    data
  });
};

// 新增|修改 主要竞争对手
export const addOrUpdateMainCompetitorApi = data => {
  return service({
    url: "/manage/saleCompetitionController/opponentInsertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 我司车型/竞品对应关系
export const addOrUpdateCompeteProductSaleApi = data => {
  return service({
    url: "/manage/saleCompetitionController/shixiaoInsertOrUpdate",
    method: "post",
    data
  });
};

// 校验删除 我司车型/竞品对应关系
export const validDeleteCompeteProductSaleApi = data => {
  return service({
    url: "/manage/saleCompetitionController/checkShixiaoDelete",
    method: "post",
    data
  });
};

// 新增|修改 我司车型/竞品产品价格
export const addOrUpdateCompeteProductPriceApi = data => {
  return service({
    url: "/manage/saleCompetitionController/priceInsertOrUpdate",
    method: "post",
    data
  });
};

// 校验删除 我司车型/竞品产品价格
export const validDeleteCompeteProductPriceApi = data => {
  return service({
    url: "/manage/saleCompetitionController/checkPriceDelete",
    method: "post",
    data
  });
};

// 获取渠道信息
export const getChannelInfoApi = data => {
  return service({
    url: "/manage/saleChannelController/saleChannelList",
    method: "post",
    data
  });
};

// 新增|修改 渠道信息
export const addOrUpdateChannelInfoApi = data => {
  return service({
    url: "/manage/saleChannelController/insertOrUpdate",
    method: "post",
    data
  });
};

// 查询区域国家信息录入数据
export const getInfoDetailApi = data => {
  return service({
    url: "/manage/saleInformationController/getInformation",
    method: "post",
    data
  });
};

// 获取看差距
export const getLookGapApi = data => {
  return service({
    url: "/manage/saleGapController/getData",
    method: "post",
    data
  });
};

// 新增|修改 业绩指标
export const addOrUpdatePerformanceIndicatorApi = data => {
  return service({
    url: "/manage/saleGapController/performanceIndicatorsInsertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 要事
export const addOrUpdateImportantEventApi = data => {
  return service({
    url: "/manage/saleGapController/somethingImportantInsertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 其他机会差距
export const addOrUpdateOtherOpportunityGapApi = data => {
  return service({
    url: "/manage/saleGapController/otherOpportunityInsertOrUpdate",
    method: "post",
    data
  });
};

// 新增|修改 其他
export const addOrUpdateRootCauseAnalysisApi = data => {
  return service({
    url: "/manage/saleGapController/rootAnalysisInsertOrUpdate",
    method: "post",
    data
  });
};

// 获取看市场
export const getLookMarketApi = data => {
  return service({
    url: "/manage/saleLookMarketController/getData",
    method: "post",
    data
  });
};

// 新增|修改 汇率变化趋势
export const addOrUpdateExchangeRateChangeTrendApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveRateChange",
    method: "post",
    data
  });
};

// 新增|修改 外汇储备
export const addOrUpdateForeignExchangeReserveApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveMoneyDay",
    method: "post",
    data
  });
};

// 新增|修改 贷款利率
export const addOrUpdateLoanRateApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveLoanInterestRate",
    method: "post",
    data
  });
};

// 新增|修改 通货膨胀率
export const addOrUpdateInflationRateApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveInflationRate",
    method: "post",
    data
  });
};

// 新增|修改 失业率
export const addOrUpdateUnemploymentRateApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveUnemploymenRateEconomicChanges",
    method: "post",
    data
  });
};

// 新增|修改 市场实销及变化趋势
export const addOrUpdateMarketSaleChangeTrendApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveMarketSale",
    method: "post",
    data
  });
};

// 新增|修改 TOP5车型 市场实销趋势
export const addOrUpdateTop5MarketSaleChangeTrendApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveTop5Sale",
    method: "post",
    data
  });
};

// 新增|修改 各品牌标杆车型 市场实销趋势
export const addOrUpdateAllBrandMarketSaleChangeTrendApi = data => {
  return service({
    url: "/manage/saleLookMarketController/saveTop5Each",
    method: "post",
    data
  });
};

// 新增|修改 总结
export const addOrUpdateConclusionApi = data => {
  return service({
    url: "/manage/saleLookSummaryController/saveSummary",
    method: "post",
    data
  });
};

// 获取看客户
export const getLookCustomerApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/getData",
    method: "post",
    data
  });
};

// 新增|修改 每月实销
export const addOrUpdateMonthlySaleApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/saveCustomerSaleList",
    method: "post",
    data
  });
};

// 新增|修改 每月进销存
export const addOrUpdateMonthlyPurchaseSaleStockApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/saveCustomerJxcList",
    method: "post",
    data
  });
};

// 新增|修改 资金计划
export const addOrUpdateFundPlanApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/saveCustomerMoneyPlanList",
    method: "post",
    data
  });
};

// 新增|修改 渠道建设计划
export const addOrUpdateChannelConstructionPlanApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/saveCustomerChannelPlanList",
    method: "post",
    data
  });
};

// 新增|修改 渠道能力评估
export const addOrUpdateChannelAbilityEvaluationApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/saveSaleChannelList",
    method: "post",
    data
  });
};

// 新增|修改 售后服务
export const addOrUpdateSaleAfterServiceApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/saveCustomerAfterSaleList",
    method: "post",
    data
  });
};

// 新增|修改 看客户信息
export const addOrUpdateCustomerInfoApi = data => {
  return service({
    url: "/manage/saleLookCustomerController/saveSaleCustomerPolicyPrice",
    method: "post",
    data
  });
};

// 新增|修改 投资人意愿评价
export const addOrUpdateInvestorEvaluationApi = data => {
  return service({
    url:
      "/manage/saleLookCustomerController/saveCustomerInvestmentEvaluationList",
    method: "post",
    data
  });
};

// 获取车辆销售总量统计
export const getSaleTotalStatisApi = data => {
  return service({
    url: "/manage/statisticsDataController/getData",
    method: "post",
    data
  });
};

// 获取竞品品牌
export const getCompeteBrandListApi = data => {
  return service({
    url: "/manage/statisticsDataController/getCompetitionSaleBrandType",
    method: "post",
    data
  });
};

// 获取车型
export const getCarModelListApi = data => {
  return service({
    url: "/manage/statisticsDataController/getCompetitionSaleCarModelType",
    method: "post",
    data
  });
};

// 获取品牌销量统计图
export const getBrandSaleStatisApi = data => {
  return service({
    url: "/manage/statisticsDataController/getCompetitionSaleBrand",
    method: "post",
    data
  });
};

// 获取车型销量价格统计图
export const getCarModelSalePriceStatisApi = data => {
  return service({
    url: "/manage/statisticsDataController/getCompetitionSaleCarModel",
    method: "post",
    data
  });
};

// 获取看竞争
export const getLookCompeteApi = data => {
  return service({
    url: "/manage/saleLookCompetitionController/getData",
    method: "post",
    data
  });
};

// 新增|修改 主要竞争对手
export const addOrUpdateCompetitorApi = data => {
  return service({
    url:
      "/manage/saleLookCompetitionController/saveSaleCompetitionOpponentList",
    method: "post",
    data
  });
};

// 新增|修改 竞品产品及实销
export const addOrUpdateCompetitiveSalesApi = data => {
  return service({
    url:
      "/manage/saleLookCompetitionController/saveSaleCompetitionProductsShixiaoLookList",
    method: "post",
    data
  });
};

// 新增|修改 竞品产品价格及政策变化
export const addOrUpdateCompetitivePriceApi = data => {
  return service({
    url:
      "/manage/saleLookCompetitionController/saveSaleCompetitionProductsPriceLookList",
    method: "post",
    data
  });
};

// 新增|修改 竞争信息
export const addOrUpdateCompeteInfoApi = data => {
  return service({
    url: "/manage/saleLookCompetitionController/saveSaleCompetitionChange",
    method: "post",
    data
  });
};

// 获取看行业
export const getLookIndustryApi = data => {
  return service({
    url: "/manage/saleLookIndustryPolicyController/getData",
    method: "post",
    data
  });
};

// 新增|修改 基本物价趋势
export const addOrUpdateBasicPriceTrendsApi = data => {
  return service({
    url: "/manage/saleLookIndustryPolicyController/saveBasicPriceTypeList",
    method: "post",
    data
  });
};

// 新增|修改 基本政策
export const addOrUpdateIndustryInfoApi = data => {
  return service({
    url: "/manage/saleLookIndustryPolicyController/saveData",
    method: "post",
    data
  });
};

// 三定-------------
// 获取数据

export const getThreeDataApi = data => {
  return service({
    url: "/manage/saleThreeController/getData",
    method: "post",
    data
  });
};
// 风险机会 
export const addOrUpdateRiskApi = data => {
  return service({
    url: "/manage/saleThreeController/saveRiskOpportunityList",
    method: "post",
    data
  });
};
// 目标   
export const addOrUpdateTargetApi = data => {
  return service({
    url: "/manage/saleThreeController/saveTargetingtyList",
    method: "post",
    data
  });
};
// 策略 
export const addOrUpdateStrategyApi = data => {
  return service({
    url: "/manage/saleThreeController/saveStrategyList",
    method: "post",
    data
  });
};
// 要事 
export const addOrUpdateImportantApi = data => {
  return service({
    url: "/manage/saleThreeController/saveMustdoList",
    method: "post",
    data
  });
};
// 费用 
export const addOrUpdateMoneyApi = data => {
  return service({
    url: "/manage/saleThreeController/saveMoneyList",
    method: "post",
    data
  });
};
// 要求事项 
export const addOrUpdateRequirementApi = data => {
  return service({
    url: "/manage/saleThreeController/saveRequirementsThingsList",
    method: "post",
    data
  });
};